import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMarketPlaceList, deleteMarketPlace } from '../../../store/marketPlace/actions';
import { useNavigate, Link } from 'react-router-dom';
import { formatDate } from '../../../helpers/formatterHelper';
import { DeleteConfrimationModal } from '../../../components/DeleteConfrimationModal/DeleteConfrimationModal';
import { showLoading, hideLoading } from '../../../store/loading-reducer';
import { useAdminMenuContext } from "../../../context/AdminMenuContext";
import { getMarketPlaceTypes } from '../../../store/marketPlace/actions';
import { getVisibilityStatus } from '../../../helpers/enums';
function MarketPlace() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { marketPlaceAllList } = useSelector(state => state.marketPlace);
    const [marketPlaceModel, setMarketPlaceModel] = useState({});
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const { marketPlaceTypesList } = useSelector(state => state.marketPlace); 
    const [filter, setFilter] = useState({ query: '', marketPlaceTypeIds: [], sort: 10 });
    const [editLink, setEditLink] = useAdminMenuContext(''); 

    useEffect(() => {
        document.title = 'Market Place | CWP Employee Portal';
        dispatch(showLoading());
        dispatch(getMarketPlaceTypes());
        setEditLink('/marketplace');
        console.log(editLink)
    }, []);

    useEffect(() => {
        dispatch(showLoading());
        dispatch(getMarketPlaceList(filter)).unwrap().then(() => {
            dispatch(hideLoading());
        })
            .catch((error) => console.error('Error fetching marketplace data:', error));
    }, [filter]);

    const handleDeleteTrigger = (id, title) => {
        setMarketPlaceModel({ id: id, title: title, message: "Are you sure you want to delete this market place" });
        setShowDeleteModal(true);
    }
    
    const handleDeleteMarketPlace = async (item) => {
        try {
            dispatch(showLoading());
            await dispatch(deleteMarketPlace(item.id));
        } catch (error) {
            console.error('Error occurred during delete or fetch operation:', error);
        } finally {
            dispatch(hideLoading());
        }
    };

    return (
        <>
            <DeleteConfrimationModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                handleDelete={handleDeleteMarketPlace}
                model={marketPlaceModel}
            />
            <div className="admin-page-wrap">
                <div className="admin-top-bar-wrap">
                    <div className="admin-top-bar-left">
                        <Link className="admin-top-bar-back" to={'/siteadmin'}>Back</Link>
                    </div>
                </div>

                <div className="pageContainer">
                    <div className="admin-page-content">
                        <div className="admin-page-title-wrap">
                            <h1 className="admin-page-heading">Market Place</h1>
                            <button className="admin-button"
                                onClick={() =>
                                    navigate('/siteadmin/marketplace/create')
                                }
                            >
                                <span>Add Market Place</span>
                                <span className="material-symbols-rounded">add</span>
                            </button>
                        </div>

                        <div className="pt">
                            <table className="admin-table">
                                <tbody>
                                    <tr>
                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 1 ? 2 : 1 })} className={filter.sort == 1 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 2 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Title</th>
                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 11 ? 12 : 11 })} className={filter.sort == 11 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 12 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Created By</th>
                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 3 ? 4 : 3 })} className={filter.sort == 3 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 4 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Type</th>
                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 5 ? 6 : 5 })} className={filter.sort == 5 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 6 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Publish Date</th>
                                        <th className="admin-table-action-cell">&nbsp;</th>
                                        <th className="admin-table-action-cell">&nbsp;</th>
                                        <th className="admin-table-action-cell">&nbsp;</th>
                                    </tr>
                                    {marketPlaceAllList && marketPlaceAllList.length > 0 ? (
                                        marketPlaceAllList.map((item) => {
                                            const matchingType = marketPlaceTypesList.find((marketPlaceType) => marketPlaceType.id === item.marketPlaceTypeId);

                                            return (
                                                <tr key={item.id}>
                                                    <td className="admin-table-name-cell">{item?.title}</td>
                                                    <td className="admin-table-name-cell"> {item?.createdByName} </td>
                                                    <td className="admin-table-name-cell">
                                                        {matchingType?.name}
                                                    </td>
                                                    <td className="admin-table-name-cell">
                                                        {item?.publishDate && item?.publishDate?.length > 0 ? (
                                                            <span>{formatDate(item?.publishDate)}</span>

                                                        ) : (
                                                            <span></span>
                                                        )}</td>
                                                    <td className="admin-table-name-cell">
                                                        {getVisibilityStatus(item?.visibility)}
                                                    </td>

                                                    <td className="admin-table-name-cell">
                                                        <button className="admin-table-action" onClick={() => navigate('/siteadmin/marketplace/edit/' + item?.baseId)}>
                                                            <span className="material-symbols-rounded">edit</span>
                                                        </button>
                                                    </td>

                                                    <td className="admin-table-name-cell">
                                                        <button className="admin-table-action" onClick={() => handleDeleteTrigger(item?.baseId, item?.title)}>
                                                            <span className="material-symbols-rounded">delete</span>
                                                        </button>
                                                    </td>

                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td className="admin-table-name-cell" colSpan="6">No active Market Place</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default MarketPlace;
